export enum TableHeadCells {
  CustomerId = 'Customer Id',
  AccountNumber = 'Account Number',
  LegalName = 'Legal Name',
  Lei = 'LEI',
  Type = "Type",
  Status = 'Status'
}
